import * as React from 'react'
import { useCustomTheme } from '/fiweb/lib/theme'
import { InfoSignIcon, Pane, Paragraph } from 'evergreen-ui'

export const NoSwedishBankIDDisclaimer = () => {
  const { spacing, colors } = useCustomTheme()
  return (
    <Pane padding={spacing.xxs} display='flex' gap={spacing.xxs}>
      <Pane paddingTop={4}>
        <InfoSignIcon color={colors.fiBlue} />
      </Pane>
      <Paragraph size={300} fontWeight='600'>
        Fra og med 01.05.2025 vil det ikke være mulig å autentisere sin brukerprofil med svensk BankID. Dette medfører
        at din profil ikke kan verifiseres og mister dessverre tilgang til enkelte tjenester på folkeinvest.no,
        inkludert tegning av aksjer.
      </Paragraph>
    </Pane>
  )
}
